import { Injectable } from '@angular/core';

import { CanActivate, Router, UrlTree } from '@angular/router';

import { Auth } from '../../services/auth/auth-service';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  constructor(
    private authService: Auth,
    private router: Router,
  ) {}

 canActivate(): boolean | UrlTree {

  if (this.authService.isLoggedIn()) {
    return this.router.createUrlTree(['/dashboard']);
  }

  return true;
}
}
